
export function createOptions(arr) {
  if (!Array.isArray(arr)) return arr
  return arr.map(createOption)
}

function createOption([name, id, disabled]) {
  return {
    name,
    id,
    disabled: !!disabled,
    selected: false
  }
}